module.exports = __webpack_public_path__ + "resources/img/img_logo_yb_kr.041c9d177bf1e91217687fede387f7d2.png";